import type { PetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import type { ProcessedDecisionMakerData } from '../../types';

import { normalizeDmsAndLBs } from './utils';

export type DMsWithLBsConnection = PetitionDetailsPageData['petition']['dmsWithLegislativeBodiesConnection'];

export function processLBConnectionData(
	dmsWithLegislativeBodiesConnection: DMsWithLBsConnection,
): ProcessedDecisionMakerData {
	const {
		nodes,
		totalCount,
		pageInfo: { hasNextPage },
	} = dmsWithLegislativeBodiesConnection;

	const dmsAndLBs = normalizeDmsAndLBs(nodes);

	return {
		totalDmCount: totalCount,
		dmsAndLBs,
		displayViewAllButton: hasNextPage,
	};
}
